/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2019. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import ReduxUtils from '../../utils/ReduxUtils';
import models from './models';
/**
 * Gets UAUserInformation from api:
 * /v1/ua/user
 *
 * @param {any} callback function to call once this function has finished
 */

var fetchUserUtil = function fetchUserUtil(callback) {
  ReduxUtils.getModelDataFromRestAPI(callback, "v1/ua/user", models.UAUserInformation);
}; // eslint-disable-next-line import/prefer-default-export


export { fetchUserUtil };